import React from 'react';
import PersonCard from './PersonCard'

const OwnerInfoSection = ({ model }) => {
    const { owner, secondOwner, annuitant, insured } = model || {};

    return (
        <div className="personCardContainer">
            <PersonCard title="Owner" person={owner} />
            <PersonCard title="Joint Owner" person={secondOwner} />
            <PersonCard title="Annuitant" person={annuitant} />
            <PersonCard title="Insured" person={insured} />
        </div>
    );
};

export default OwnerInfoSection;